/**
 * Sticky Navigation Handler
 * Makes the floating navigation sticky and full-width when scrolling
 * Only applies on desktop - mobile uses CSS sticky positioning
 * Works on all pages (homepage and other pages)
 */

document.addEventListener('DOMContentLoaded', function() {
  const navbar = document.querySelector('.navbar-floating');

  if (!navbar) return; // Exit if no floating navbar found

  // Only apply sticky behavior on desktop (>= 992px)
  // On mobile, CSS handles sticky positioning
  const isDesktop = () => window.innerWidth >= 992;

  let isSticky = false;
  let navbarInitialTop = 0;

  // Calculate the navbar's initial position from the top of the document
  function calculateInitialPosition() {
    if (!isDesktop()) return;

    // Remove sticky class temporarily to get true position
    const wasSticky = navbar.classList.contains('is-sticky');
    if (wasSticky) {
      navbar.classList.remove('is-sticky');
    }

    // Get position relative to document
    const rect = navbar.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    navbarInitialTop = rect.top + scrollTop;

    // Restore sticky class if it was there
    if (wasSticky) {
      navbar.classList.add('is-sticky');
    }
  }

  function handleScroll() {
    // Skip on mobile - CSS handles it
    if (!isDesktop()) {
      // Remove sticky class if it was added before resize
      if (isSticky) {
        isSticky = false;
        navbar.classList.remove('is-sticky');
      }
      return;
    }

    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

    // Navbar should become sticky when scroll position reaches the navbar's initial position
    const stickyThreshold = navbarInitialTop;

    if (scrollPosition >= stickyThreshold && !isSticky) {
      isSticky = true;
      navbar.classList.add('is-sticky');
    } else if (scrollPosition < stickyThreshold && isSticky) {
      isSticky = false;
      navbar.classList.remove('is-sticky');
    }
  }

  // Listen to scroll events with throttling for better performance
  let ticking = false;
  window.addEventListener('scroll', function() {
    if (!ticking) {
      window.requestAnimationFrame(function() {
        handleScroll();
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });

  // Handle window resize
  window.addEventListener('resize', function() {
    calculateInitialPosition();
    if (!ticking) {
      window.requestAnimationFrame(function() {
        handleScroll();
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });

  // Calculate initial position and do initial check
  calculateInitialPosition();
  handleScroll();
});

